import React, { useState,useEffect } from 'react'
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Switch,
    Tooltip,
    Select
} from '@chakra-ui/react'
import { VscEdit } from 'react-icons/vsc'
import { useDispatch } from 'react-redux';
import { updateCiudad, getCiudades } from '../../features/ciudadSlice';
import { useSelector } from 'react-redux';
import { getListSelectPais } from '../../features/paisSlice';

export const ModalEditarCiudad = ({ row, page, perPage }) => {
    //const isFormValid = !!indice.ciudad?.trim() && !!indice.paisId;
    const dispatch = useDispatch();
    const { paises } = useSelector((state) => state.paises); // Suponiendo que el reducer se llama 'pais'
   // const user = useSelector(state => state.auth.user);

   useEffect(() => {
        dispatch(getListSelectPais());
    }, [dispatch]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        ciudadNombre: '',
        paisId: '',
        estado: null
    }

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = (data) => {
        setIsModalOpen(true);
        setIndice({ ...data }); // ✅ Clona el objeto para evitar referencias circulares
    };

    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    const handleUpdate = (indice) => {
        dispatch(updateCiudad(indice)).then(() => {
            dispatch(getCiudades({ page, perPage })); // Usa los valores pasados como props y Actualiza la tabla después de eliminar
            setIsModalOpen(false); // Cierra el modal
        });
    };
    const isFormValid = !!indice.ciudadNombre?.trim() && !!indice.paisId;

    return (
        <>
            <Tooltip hasArrow label='Editar' placement='auto'>
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit}
                        fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR CIUDAD</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} direction="column" justifyContent="space-between" p={4}>
                        
                            <Stack direction="row" justifyContent="space-between" w="full">
                                <Text fontWeight="semibold">ESTADO</Text>
                                <Switch onChange={(e) => setIndice({ ...indice, estado: e.target.checked })} value={indice ? indice.estado : null} colorScheme="purple" isChecked={indice.estado === true ? true : false} size='lg' />
                            </Stack>

                            <Stack spacing={4} direction="row" justifyContent="space-between">
                                {/* <FormControl>
                                    <FormLabel fontWeight="semibold">ID</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.id : ''}
                                        placeholder="Escribe la descripcion"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, id: e.target.value })}
                                        isReadOnly // Esto bloquea el campo ID, no permitiendo su edición
                                    />
                                </FormControl> */}
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">Ciudad</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.ciudadNombre : ''}
                                        placeholder="Escribe la ciudad"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, ciudadNombre: e.target.value })}
                                    />
                                </FormControl>
                                <FormControl isRequired>
                                    <FormLabel fontWeight={'semibold'}>PAIS</FormLabel>
                                    <Select
                                         placeholder="Selecciona un país"
                                         onChange={(e) => setIndice({ ...indice, paisId: parseInt(e.target.value) })}
                                         value={indice.paisId || ''}
                                    >
                                        {paises.map((pais) => (
                                            <option key={pais.id} value={pais.id}>
                                                {pais.descripcion}
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Stack>
                          
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            size="lg"
                            mr={3}
                            onClick={() => handleUpdate(indice)} // ✅ Ahora pasa `indice`
                            borderRadius="xl"
                            isDisabled={!isFormValid}
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
